import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';

import flexErrors from '../../../../../../src/constants/flex-errors';
import FSFlatButton from '../../../../../../src/components/lib/FSFlatButton';
import UnifiedSearch from '../../../../../FlightSearch/components/children/UnifiedSearch/UnifiedSearch';
import componentBase from '../../../../../../src/lib/component-base';
import { setFlightTrackerSearchError, setSecondarySearchAction } from '../../../../redux/Search/actions';

@connect(state => ({
  error: state.FlightTrackerSearch.error,
  secondarySearchAction: state.FlightTrackerSearch.secondarySearchAction,
}))
@componentBase('FlightSearch')
export default class FlightSearch extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func,
    error: PropTypes.string,
    secondarySearchAction: PropTypes.bool,
  };

  componentWillUnmount() {
    this.props.dispatch(setSecondarySearchAction(false));
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.secondarySearchAction) {
      this.submit();
      this.props.dispatch(setSecondarySearchAction(false));
    }
  }

  submit = (e) => {
    e && e.preventDefault && e.preventDefault();

    const { dispatch } = this.props;
    const { child } = this;

    if (child) {
      this.context.reportButtonPress('Search');

      const errorCode = child.validate();

      dispatch(setFlightTrackerSearchError(errorCode));

      if (errorCode == null && child.url) {
        dispatch(push(child.url));
      }
    }
  };

  gotoAdvancedSearch = () => this.context.reportButtonPress('Go to Advanced Search');

  render() {
    let error = '';

    if (this.props.error) {
      error = (
        <div className='row'>
          <div className='col-lg-7 col-md-6' style={{ padding: '0 20px' }}>
            <p className='search-error-text'>{flexErrors(this.props.error)}</p>
          </div>
        </div>
      );
    }

    return (
      <section className='flight-tracker-result-search'>
        <h4>Flight Tracker</h4>
        {error}
        <div className='row'>
          <form
            onSubmit={this.submit}
            ref={el => this.form = el}
          >
            <div className='search-bar col-lg-7 col-md-6' style={{ paddingLeft: '20px', paddingRight: '20px' }}>
              <UnifiedSearch
                ref={el => this.child = el}
                dispatch={this.props.dispatch}
              />
            </div>
            <div className='button-container col-lg-4 col-md-5' style={{ padding: '0 20px 10px' }}>
              <FSFlatButton
                label='Search'
                onClick={this.submit}
                style={FSFlatButton.style({ margin: null, minWidth: null, width: '48%' })}
                className='search-button'
              />
              <div className='button-spacer' />
              <Link to='/flight-tracker/search/advanced' className='advanced-button-mobile'>
                <FSFlatButton
                  label='Advanced'
                  onClick={this.gotoAdvancedSearch}
                  style={FSFlatButton.style({ margin: null, minWidth: null, float: null })}
                />
              </Link>
              <Link to='/flight-tracker/search/advanced' className='advanced-button-non-mobile'>
                <FSFlatButton
                  label='Advanced Search'
                  onClick={this.gotoAdvancedSearch}
                  style={FSFlatButton.style({
                   margin: null, minWidth: null, float: 'right', width: '48%', marginRight: '0',
                  })}
                />
              </Link>
            </div>
          </form>
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/FlightTracker/components/Search/children/FlightSearch/FlightSearch.js